<template>
  <BModal
    id="modal-tall"
    :model-value="modal"
    scrollable
    centered
    title="Payment"
    @update:modelValue="updateModal"
  >
    <template #header>
      <div
        class="d-flex align-items-center justify-content-between modal-title w-100"
      >
        <h5 class="">Payment</h5>
        <!-- <div class="d-flex align-items-center">
          <span class="mr-2">17/02/2025 16:00:00</span>
          <div
            class="bg-success rounded-circle"
            style="width: 10px; height: 10px"
          ></div>
          <span>online: Ruth</span>
        </div> -->
      </div>
      <BButton variant="link" class="close" @click="updateModal(false)">
        <i class="ion ion-android-close"></i>
      </BButton>
    </template>
    <BForm>
      <div class="form-group">
        <BFormInput
          type="hidden"
          v-model="paymentForm.reservation_merge_uuid"
          :value="uuid"
        />
        <BFormSelect v-model="paymentForm.payment_method_uuid" class="">
          <template #first>
            <BFormSelectOption :value="null" disabled>
              Select payment method
            </BFormSelectOption>
          </template>
          <BFormSelectOption
            v-for="method in paymentMethods"
            :key="method.uuid"
            :value="method.uuid"
          >
            {{ method.name }} {{ method.number }}
          </BFormSelectOption>
        </BFormSelect>
      </div>
      <div class="form-group">
        <label>Remaining Bill: {{ formatIDR(bill.sisa_tagihan) }}</label>
        <BFormInput
          type="number"
          v-model="paymentForm.amount"
          placeholder="nominal amount to be paid"
        >
        </BFormInput>
      </div>
      <div class="form-group">
        <label for="">Payment Date</label>
        <BFormInput type="date" v-model="paymentForm.payment_date">
        </BFormInput>
      </div>

      <div class="form-group">
        <BFormTextarea
          v-model="paymentForm.description"
          placeholder="Remarks(Optional)"
          rows="3"
        />
      </div>
    </BForm>
    <template #footer>
      <div class="d-flex justify-content-end">
        <BButton
          variant="primary"
          @click="payBill()"
          class="mr-2"
          :disabled="isLoading"
        >
          {{ isLoading ? "Loading..." : "Pay" }}</BButton
        >
        <BButton variant="danger" @click="updateModal(false)">Cancel</BButton>
      </div>
    </template>
  </BModal>
  <ToastResponse
    v-model="modalResponse.toast"
    :text="modalResponse.text"
    :success="modalResponse.success"
  ></ToastResponse>
</template>

<script>
import { inject, ref, watch } from "vue";
import ToastResponse from "@/components/ToastResponse.vue";
import { formatIDR } from "@/utils/currency";
import { dateFormatter } from "@/utils/dateFormatter";

import {
  BModal,
  BFormInput,
  BFormSelect,
  BFormSelectOption,
  // BInputGroup,
  BButton,
  // BListGroup,
  // BListGroupItem,
  BFormTextarea,
  BForm,
  // BFormRadioGroup,
} from "bootstrap-vue-next";
export default {
  props: {
    modal: Boolean,
    uuid: String,
  },
  name: "CheckInForm",
  components: {
    BModal,
    BForm,
    BFormInput,
    BFormSelect,
    BFormSelectOption,
    //   BInputGroup,
    BButton,
    // BListGroup,
    // BListGroupItem,
    BFormTextarea,
    // BFormRadioGroup,
    ToastResponse,
  },

  emits: ["update:modal", "paid"],

  setup(props, { emit }) {
    const repositories = inject("repositories");
    const billRepository = repositories ? repositories.reservationMerge : null;
    const paymentMethodRepository = repositories
      ? repositories.paymentMethod
      : null;
    const isLoading = ref(false);

    const options = ref([
      {
        text: "Ya",
      },
      {
        text: "Tidak",
      },
    ]);

    const modalResponse = ref({
      toast: false,
      text: "",
      success: false,
    });

    const selectedPaymentMethod = ref(null);
    const paymentMethods = ref([]);

    const paymentForm = ref({
      reservation_merge_uuid: props.uuid,
      payment_method_uuid: null,
      payment_type: "Payment",
      payment_date: null,
      amount: null,
      reference_number: null,
    });

    const bill = ref({
      reservation: {},
      guest: {},
      grand_total: 0,
      total_paid: 0,
      sisa_tagihan: 0,
      payments: [{}],
    });

    const updateModal = (value) => {
      emit("update:modal", value); // Sync modal state with parent
    };

    const resetForm = () => {
      paymentForm.value = {
        reservation_merge_uuid: props.uuid,
        payment_method_uuid: null,
        payment_type: "Payment",
        payment_date: null,
        amount: null,
        reference_number: null,
      };
    };

    const getBill = async (uuid) => {
      isLoading.value = true;
      try {
        const response = await billRepository.getBill(uuid);
        bill.value = response.data;
      } catch (error) {
        console.log(error);
      } finally {
        isLoading.value = false;
      } 
    };

    const payBill = async () => {
      try {
        isLoading.value = true;
        const response = await billRepository.payBill(paymentForm.value);
        modalResponse.value = {
          toast: true,
          text: response.data.message,
          success: true,
        };
        emit("paid");
        updateModal(false);
        resetForm();
        isLoading.value = false;
      } catch (error) {
        isLoading.value = false;
        modalResponse.value = {
          toast: true,
          text: error.response.data.message,
          success: false,
        };
      }
    };

    const getListPaymentMethod = () => {
      paymentMethodRepository
        .getAll()
        .then((res) => {
          paymentMethods.value = [
            ...res.data.data.filter((i) => (i.status === "active" ? i : null)),
          ];
        })
        .catch((err) => {
          console.error(err);
        });
    };

    watch([() => props.modal, () => props.uuid], ([modalVal, uuidVal]) => {
      paymentForm.value.reservation_merge_uuid = uuidVal;
      if (modalVal && uuidVal) {
        getBill(uuidVal);
        getListPaymentMethod();
      }
    });

    return {
      bill,
      getBill,
      payBill,
      getListPaymentMethod,
      billRepository,
      paymentMethodRepository,
      paymentForm,
      updateModal,
      dateFormatter,
      modalResponse,
      isLoading,
      paymentMethods,
      selectedPaymentMethod,
      options,
      formatIDR,
    };
  },
};
</script>

<style></style>
